import { render, staticRenderFns } from "./ForcePasswordChangeModal.vue?vue&type=template&id=56c67c7a&scoped=true"
import script from "./ForcePasswordChangeModal.vue?vue&type=script&lang=js"
export * from "./ForcePasswordChangeModal.vue?vue&type=script&lang=js"
import style0 from "./ForcePasswordChangeModal.vue?vue&type=style&index=0&id=56c67c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c67c7a",
  null
  
)

export default component.exports